<template>
  <div class="slideshow">
    <div class="content">
      <p v-for="(sponsor, index) in sponsors" :key="index">
        <a :href="sponsor.url" target="_new">
          <img
            :src="sponsor.image"
            :alt="'Bild unseres Sponsors ' + sponsor.name"
            :title="sponsor.name"
            width="260"
          />
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sponsors",
  props: {
    msg: String,
  },

  data() {
    return {
      sponsors: [
        {
          name:
            "Stadt Kempten — Gleichstellungsbeauftragte für Bürger und Bürgerinnen",
          url: "https://www.kempten.de/gleichstellungsstelle-1395.html",
          image: "/assets/sponsor-1.png",
        },
        {
          name: "Runder Tisch gegen Häusliche Gewalt Kempten",
          url: "https://www.kempten.de/Kempten-gegen-Gewalt-29558.html",
          image: "/assets/sponsor-5.png",
        },
        {
          name: "Hochschule Kempten",
          url: "https://www.hs-kempten.de",
          image: "/assets/sponsor-2.png",
        },
        {
          name: "Stadt Kempten — Demokratie leben",
          url: "https://www.kempten.de/demokratie-leben-25223.html",
          image: "/assets/sponsor-3.png",
        },
        {
          name: "Raiba hilft e. V.",
          url: "https://www.raiba-ke-oa.de/wir-fuer-sie/raiba-hilft-e--v-.html",
          image: "/assets/sponsor-4.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: space-between;
}

.slideshow .content {
  background: none !important;
  justify-content: left;
}

.content p {
  margin: 0 5px 0 0;
}
</style>
